<template>
    <b-modal id="signature_delete" ref="signature_delete"
             :title="'Delete Signature For ' + signature.data.attributes.code + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('signature_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteSignature">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "SignatureDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'signature',
    ],

    methods: {
        deleteSignature() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteSignature', this.signature.signature_id)
                    .then(() => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-signature');

                            this.$notify('error filled', 'Success!', 'Deleted the signature!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('signature_delete');
                        }, 2000);
                    })
                    .catch(errors => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },
    },
}
</script>

<style scoped>

</style>
